jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.calendar').length ) {

        let $ = jQuery;
        const $container = $(".js-calendar-wrapper");
        const $loadMoreBtn = $("#load-more-events");
        const $eventFilter = $(".event-filter");

        var $lastDay, $today, $category, $month, $year;

        $eventFilter.on("change", function () {
           $dataFor = $(this).data('for');
           $value = $(this).val();
           $container.attr('data-'+$dataFor, $value);
           if($dataFor == 'year' && $container.attr('data-month') == '') {
               return;
           }
           $container.empty();
           // $loadingWheel.show();
           loadResults();
        });


        $loadMoreBtn.on("click", function () {
            loadResults();
        });



        function loadResults() {

            $lastDay = $container.attr('data-last_day');
            $today = $container.attr('data-today');
            $category = $container.attr('data-category');
            $month = $container.attr('data-month');
            $year = $container.attr('data-year');


            var sendData = {
                action: 'events_ajax_handler',
                startDate: $lastDay,
                category: $category,
                today: $today,
                month: $month,
                year: $year,
            };

            $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                beforeSend: function() {
                    // $loadMoreEntriesContainer.hide();
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    // $loadMoreEntriesContainer.remove();
                },
                success: function(data, textStatus, jqXHR) {
                    var htmlData = $.parseHTML(jqXHR.responseText);
                    $container.append(htmlData);
                    $days = $container.find(".updatedays");
                    $nextDays = $days.data('newstart');
                    $container.attr('data-last_day', $nextDays);

                },
                complete: function(data) {
                    if (data.responseText !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                    } else {
                        $loadMoreBtn.fadeOut();
                    }
                    AOS.init();
                }
            });
        }

    }
});